import cx from 'classnames'
import Skeleton from 'react-loading-skeleton'

type GenericDataCardItemProps = {
  className?: string
  heading: string
}
interface PendingDataCardItemProps extends GenericDataCardItemProps {
  isLoading: true
  value?: string | number
}
interface LoadedDataCardItemProps extends GenericDataCardItemProps {
  isLoading: false
  value: string | number
}
type DataCardItemProps = PendingDataCardItemProps | LoadedDataCardItemProps

export function DataCardItem (props: DataCardItemProps) {
  return (
    <div
      className={cx(
        'ds-display--flex ds-u-flex-direction--column',
        props.className
      )}
    >
      <div className="ds-text-body--md ds-u-margin-bottom--0">
        {props.heading}
      </div>
      <div className="ds-text-body--lg ds-u-font-weight--semibold">
        {props.isLoading ? <Skeleton /> : props.value}
      </div>
    </div>
  )
}
